export enum CanvasBreakpoint {
  XSMALL = 320,
  SMALL = 500
}
